import React from 'react';
import { useTranslation } from 'react-i18next';

import { analyticSDK } from '#analytics/wbsdk-analytic';
import { isZoneRu } from '#helper/is-zone-ru';

import { TNavItems } from '#component/header/types';

import { useCountryCode } from './use-country-code';
import { useConfigFetch } from './use-config-fetch';
import { NewsCounter } from './components/news-counter';
import { PromotionsAlert } from './components/promotions-alert';

export const useNavItems = () => {
    const { t } = useTranslation();

    const [newsCount, setNewsCount] = React.useState<number>(0);

    const { isChinese, isRussian } = useCountryCode();
    const { config } = useConfigFetch();

    const campaignOptions = [
        {
            to       : '/campaigns/list',
            text     : t('components.header.nav-tabs.campaigns.campaigns'),
            analytics: () => analyticSDK.myCampaignsV({})
        },
        {
            to       : '/campaigns/statistics',
            text     : t('components.header.nav-tabs.campaigns.statistics'),
            analytics: () => analyticSDK.statisticsMainV({})
        },
        {
            to       : '/campaigns/finances',
            text     : t('components.header.nav-tabs.campaigns.finances'),
            analytics: () => analyticSDK.financesMainV({})
        },
        {
            to               : '/campaigns/news',
            text             : t('components.header.nav-tabs.campaigns.news'),
            analytics        : () => analyticSDK.newsMainV({ unread_count: newsCount }),
            additionalContent: <NewsCounter setNewsCount={setNewsCount} />
        },
        {
            to       : '/campaigns/help',
            text     : t('components.header.nav-tabs.campaigns.help'),
            analytics: () => analyticSDK.faqMainV({})
        }
    ];

    if(!isChinese && config?.uiPromotionsFeature) {
        // eslint-disable-next-line no-nested-ternary
        const text = t(`components.header.nav-tabs.campaigns.${config?.unifiedAccountEnabled ? isRussian ? 'promotions-unified-ru' : 'promotions-unified' : 'promotions'}`);

        campaignOptions.push({
            to               : '/campaigns/promotions',
            text,
            analytics        : () => analyticSDK.myBonusesMainV({}),
            additionalContent: <PromotionsAlert />
        });
    }

    const navItems: TNavItems = {
        '/campaigns': {
            to     : '/campaigns',
            text   : t('components.header.tabs.campaigns'),
            options: campaignOptions
        },
        '/media': {
            to            : '/cmpf',
            text          : t('components.header.tabs.media'),
            reloadDocument: true
        },
        '/bz': {
            to            : '/bz',
            text          : t('components.header.tabs.bz'),
            reloadDocument: true
        },
        '/bs': {
            to            : '/bs',
            text          : t('components.header.tabs.bs'),
            reloadDocument: true
        },
        '/external-traffic': {
            to  : '/external-traffic/',
            text: t('components.header.tabs.traffic')
        }
    };

    if(isRussian) {
        navItems['/influence'] = {
            to            : '/influence',
            text          : t('components.header.tabs.influence'),
            reloadDocument: true
        };
    }

    // @TODO: Временно поставил. Надо немного отрефакторить логику формирования
    return isZoneRu
        ? navItems
        : Object.fromEntries(Object.entries(navItems).filter(([key]) => !['/media', '/bz', '/bs'].includes(key)));
};
